import React, { createContext, useContext, useState, useCallback } from 'react';
import * as api from '../services/api';

const TaskContext = createContext(null);

export function TaskProvider({ children }) {
  const [parentTask, setParentTask] = useState(null);
  const [childTasks, setChildTasks] = useState([]);

  const fetchChildTasks = useCallback(async (parentId) => {
    try {
      const tasks = await api.getChildTasks(parentId);
      setChildTasks(tasks);
    } catch (err) {
      console.error('Error fetching child tasks:', err);
    }
  }, []);

  const loadTask = useCallback(async (parentId) => {
    if (!parentId) {
      setParentTask(null);
      setChildTasks([]);
      return;
    }
    try {
      const task = await api.getTask(parentId);
      setParentTask(task);
      await fetchChildTasks(parentId);
    } catch (err) {
      console.error('Error fetching parent task:', err);
    }
  }, [fetchChildTasks]);

  const refreshChildren = useCallback(() => {
    if (parentTask?.uuid) {
      fetchChildTasks(parentTask.uuid);
    }
  }, [parentTask, fetchChildTasks]);

  return (
    <TaskContext.Provider value={{ parentTask, childTasks, setChildTasks, loadTask, refreshChildren }}>
      {children}
    </TaskContext.Provider>
  );
}

export function useTaskContext() {
  const ctx = useContext(TaskContext);
  if (!ctx) throw new Error('useTaskContext must be used within a TaskProvider');
  return ctx;
}
